/* eslint-disable */
import PropTypes from 'prop-types';

/**
 * An order
 */
const order = PropTypes.shape({
  /**
   * The `id` of the order
   */
  id: PropTypes.string.isRequired,
});

/**
 * The order quantity
 */
const quantity = PropTypes.shape({
  /**
   * The dispatched amount for the order
   */
  dispatchedAmount: PropTypes.string.isRequired,

  /**
   * The ordered amount for the order
   */
  orderedAmount: PropTypes.string.isRequired,

  /**
   * The unit of measure for the order
   */
  unitOfMeasure: PropTypes.string.isRequired,
});

/**
 * The order summary
 */
const summary = PropTypes.shape({
  /**
   * The order time (and date)
   */
  startTime: PropTypes.string.isRequired,

  /**
   * The order status
   */
  status: PropTypes.string.isRequired,

  /**
   * The order sub title
   */
  subTitle: PropTypes.string.isRequired,

  /**
   * The order title
   */
  title: PropTypes.string.isRequired,
});

const OrderEntityPropTypes = {
  /**
   * An order
   */
  order,

  /**
   * The order quantity
   */
  quantity,

  /**
   * The order summary
   */
  summary,
};

export default OrderEntityPropTypes;
